import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Standard frame for a grid screen. Owns the page-level layout — optional title
 * and an edge-to-edge, full-height column — and projects an <app-grid> inside.
 *
 * Every grid consumer wraps its <app-grid> in this shell so all grid pages share
 * one identical frame; consumers never hand-roll their own wrapper (which is how
 * they drifted apart before). Matches the Claude design: no floating card, the
 * grid fills its area, the title sits above the grid's own toolbar.
 *
 * Grid pages sit inside the standard shell gutter (p-4 on <main>) like every
 * other page — since the CMS redesign the grid and detail panel are floating
 * rounded cards that need clear space to the sidebar and viewport edges.
 *
 *   <app-grid-page [title]="'User Management'">
 *     <app-grid …>…</app-grid>
 *   </app-grid-page>
 */
@Component({
  selector: 'app-grid-page',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="flex h-full min-h-0 flex-col">
      <div class="min-h-0 flex-1">
        <ng-content></ng-content>
      </div>
    </div>
  `,
})
export class GridPage {
  /**
   * Unused since the topbar took over page headings (it renders the route's
   * title key, DS PageHeader style). Kept so the 20+ existing
   * `<app-grid-page [title]="…">` bindings stay valid; remove once consumers
   * drop the binding.
   */
  readonly title = input<string>('');
}
